export default "__VITE_ASSET__C5llq9Ah__"